import type { RouterOutput } from "~/libs/trpc.lib";

export type Board = RouterOutput["boards"]["list"][number];

/** Derived layout shape used by react-grid-layout. Built from block position fields. */
export interface BoardLayoutItem {
  i: string;
  x: number;
  y: number;
  w: number;
  h: number;
  minW?: number;
  minH?: number;
}

/**
 * Grid configuration
 */
export interface GridConfig {
  cols: number;
  rowHeight: number;
  margin: readonly [number, number];
  containerPadding: readonly [number, number];
}

/**
 * Default grid configuration
 */
export const DEFAULT_GRID_CONFIG: GridConfig = {
  cols: 12,
  rowHeight: 64,
  margin: [12, 12],
  containerPadding: [0, 0],
};
